import Swiper, { Autoplay, EffectFade } from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', () => {
  const initSwiper = (): void => {
    const swiperElement = document.querySelector<HTMLElement>('.p-aboutSwiper');
    const swiperElementMv = document.querySelector<HTMLElement>(
      '.p-topMainVisualSwiper'
    );
    const swiperElementPlan =
      document.querySelector<HTMLElement>('.p-planSwiper');

    if (swiperElement) {
      const swiper = new Swiper('.p-aboutSwiper', {
        modules: [Autoplay],

        // スライドの基本設定
        slidesPerView: 'auto',
        // spaceBetween: 24,
        loop: true,
        speed: 10000, // ゆっくりとした連続的な動き
        allowTouchMove: false, // タッチ・ドラッグ操作を無効化
        centeredSlides: true, // スライドを中央揃えに

        // 自動再生の設定
        autoplay: {
          delay: 0, // 遅延なしの連続的な動き
          disableOnInteraction: false, // ユーザーの操作後も継続
        },
      });
    }

    if (swiperElementPlan) {
      const swiperPlan = new Swiper('.p-planSwiper', {
        modules: [Autoplay],

        // スライドの基本設定
        slidesPerView: 'auto',
        // spaceBetween: 24,
        loop: true,
        speed: 10000, // ゆっくりとした連続的な動き
        allowTouchMove: false, // タッチ・ドラッグ操作を無効化
        centeredSlides: true, // スライドを中央揃えに

        // 自動再生の設定
        autoplay: {
          delay: 0, // 遅延なしの連続的な動き
          disableOnInteraction: false, // ユーザーの操作後も継続
          reverseDirection: true,
        },
      });
    }

    if (swiperElementMv) {
      const swiperMv = new Swiper('.p-topMainVisualSwiper', {
        modules: [Autoplay, EffectFade],

        // スライドの基本設定
        loop: true,
        loopAdditionalSlides: 1,
        speed: 3000, // ゆっくりとした連続的な動き
        allowTouchMove: false, // タッチ・ドラッグ操作を無効化

        // 自動再生の設定
        autoplay: {
          delay: 4000, // 遅延なしの連続的な動き
          disableOnInteraction: false, // ユーザーの操作後も継続
          waitForTransition: false,
        },

        // エフェクトの設定
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
      });
    }
  };

  initSwiper();
});
